import {Col, Input, Row} from 'antd';
import Form, {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import * as React from 'react';
import {WithTranslation} from 'react-i18next';
import {nameof} from '../../../../core/utils/object';
import {NewProjectTemplateItem, ProjectTemplateItem} from '../../../../stores/templates-store';

let FormItem = Form.Item;


interface ClassFormBodyProps extends WithTranslation {
    item: ProjectTemplateItem | NewProjectTemplateItem | undefined,
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    disabled?:boolean
}

class ProjectTemplateFormBody extends React.Component<ClassFormBodyProps> {
    render() {
        const { t, getFieldDecorator } = this.props;

        var item = this.props.item as NewProjectTemplateItem || {} as NewProjectTemplateItem;
        return (
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={t("Project template name")}>
                        {getFieldDecorator(nameof<NewProjectTemplateItem>('title'), {
                            initialValue: item.title,
                            rules: [{ required: true, message: t('Title required') },
                                { whitespace: true, message: t('Title required') }],
                        })(
                            <Input disabled={this.props.disabled} placeholder={t("Project template name")} type="text" />
                        )}
                    </FormItem>
                </Col>
            </Row>
        )
    }
}


// Wire up the React component to the Redux store
export default ProjectTemplateFormBody;
